export const theme = {
  colors: {
    highlight: '#FEEA00',
    textPrimary: '#111111',
    textSecondary: '#666666',
    bgLight: '#F5F5F5',
  },
  breakpoints: {
    mobile: '768px',
    tablet: '1024px',
  },
}